// Resolves image paths from public/images so content JSON only stores filenames.
// Using PUBLIC_URL keeps paths correct when deployed under a subpath (e.g. GitHub Pages).
const PUBLIC = process.env.PUBLIC_URL || "";

export const propertyImage = (folder, file) => `${PUBLIC}/images/${folder}/${file}`;

export const sharedImage = (file) => `${PUBLIC}/images/shared/${file}`;

export const asset = (path) => `${PUBLIC}${path.startsWith("/") ? "" : "/"}${path}`;
